export default "__VITE_ASSET__BZBztSJm__"